import styled from 'styled-components'

export const Stamp = styled.div`
    align-items: center;
    background-color: #EDECF2;
    border-radius: 12px;
    color: #6A6977;
    display: flex;
    font-size: 10px;
    font-weight: 500;
    height: 18px;
    justify-content: center;
    left: 6px;
    padding: 0 8px;
    position: absolute;
    top: 6px;
    z-index: 1;
`